import React from 'react';
import { Link } from 'react-router';
import {
  IconCreditCardPay,
  IconInputSearch,
  IconLockFilled,
  IconRefresh,
} from '@tabler/icons-react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { useSelector } from 'react-redux';
// import { OverlayTrigger, Popover } from 'react-bootstrap';
import subscriptionInactive from '../../assets/images/subscription-inactive.svg';

const Landing = () => {
  const { isActive: isSubscriptionActive } = useSubscription();

  // Get user role from Redux store
  const currentUserRole = useSelector(
    (state) => state.auth?.userAttributes['custom:role'],
  );

  // Check if user is an organization admin who can manage subscriptions
  const isOrgAdmin = currentUserRole === 'org_admin';

  // Helper function to render a module card with optional disabled state
  const renderModuleCard = ({ to, icon, title, description }) => {
    const cardContent = (
      <li className={!isSubscriptionActive ? 'disabled opacity-30' : ''}>
        {icon}
        <div className="list-label">
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
        <div className="arrow-box">
          {isSubscriptionActive ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right arrow"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 12l14 0" />
              <path d="M15 16l4 -4" />
              <path d="M15 8l4 4" />
            </svg>
          ) : (
            <IconLockFilled size={24} className="text-secondary mx-1" />
          )}
        </div>
      </li>
    );

    if (!isSubscriptionActive) {
      return (
        <div style={{ cursor: 'not-allowed' }} className="position-relative">
          <div className="opacity-50">{cardContent}</div>
        </div>
      );
    }

    return (
      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
        {cardContent}
      </Link>
    );
  };

  // Render message content based on user role
  const renderSubscriptionAlertContent = () => {
    if (isOrgAdmin) {
      return (
        <>
          <div className="container py-2 text-center">
            <div className="mb-4">
              <img src={subscriptionInactive} alt="Subscription Inactive" />
            </div>
            {/* Expired Message */}
            <div className="w-75 mx-auto">
              <h4 className="fw-bold mb-2 text-two-lines">
                Your subscription has expired, but don’t worry — it’s easy to
                get back on track!
              </h4>

              <p className="text-muted mb-4 text-two-lines px-5">
                Renew now to continue enjoying full access to all the features
                you love. We’d love to have you back!
              </p>
            </div>
            {/* Renew Button */}
            <Link to={'/settings/organization/billing'}>
              <button className="btn bg-primary text-white d-block mx-auto">
                <IconRefresh size={18} className="mx-1" /> Renew Subscription
              </button>
            </Link>
          </div>
        </>
      );
    } else {
      return (
        <>
          <strong>Your organization's subscription is inactive.</strong>{' '}
          Features are limited. Please contact your organization administrator
          to activate the subscription.
        </>
      );
    }
  };

  return (
    <>
      <div className="">
        <div className="fixed-container-center">
          {!isSubscriptionActive && (
            <>
              <div className="d-flex align-items-center">
                <div>{renderSubscriptionAlertContent()}</div>
              </div>
            </>
          )}
          <div className="">
            <h1 className="select-module-title">Select a module to continue</h1>
            <ul className="d-flex flex-wrap align-items-center justify-content-center select-action">
              {renderModuleCard({
                to: '/landing/coverage-verification',
                icon: (
                  <IconCreditCardPay
                    className="icon icon-tabler icons-tabler-outline left-icon"
                    size={36}
                  />
                ),
                title: 'Coverage Verification',
                description:
                  'Instantly check prescription coverage to streamline treatment decisions.',
              })}

              {renderModuleCard({
                to: '/landing/drug-search',
                icon: (
                  <IconInputSearch
                    className="icon icon-tabler icons-tabler-outline left-icon"
                    size={36}
                  />
                ),
                title: 'Drug Search',
                description:
                  'Access detailed drug information with a quick search.',
              })}
            </ul>
          </div>
        </div>
        <div className="innerpage detailed-page"></div>
      </div>
    </>
  );
};

export default Landing;
